package com.questions.model

import kotlinx.serialization.Serializable
import kotlin.collections.List

@Serializable
data class Question(
    var questionId: Double,
    var question: String,
    var answer1: String,
    var answer2: String,
    var answer3: String,
    var answer4: String,
    var rightAnswer: List<String>,
    var explanation: String // NEW: explanation shown after user submits
)
